import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { AuthRedirect } from 'components'
import { actions as actionsAssistantData } from 'appRedux/modules/AssistantData'
import { actions as actionsListLab } from 'appRedux/modules/ListLab'
import { actions as actionsTabToggler } from 'appRedux/modules/TabToggler'
import { actions as actionsProduct } from 'appRedux/modules/Product'
import { Toolbar as component } from './Toolbar'


const mapStateToProps = (state, ownProps) => ({
	searchlistLabResult: state.AssistantData.searchResult,
	listLabData: state.ListLab.data,

	is_mobile: state.Layout.is_mobile,
	width: state.Layout.width,
	products: state.Product.products,
	side_menu_hidden: state.SideMenu.side_menu_hidden,
	stock: state.Stock.select_stock,
});
const mapDispatchToProps = (dispatch, ownProps) => ({
	onSearchGetRequest: (labID) => dispatch(actionsListLab.getRequest(labID)),
	onSingleSearch: (data) => dispatch(actionsAssistantData.searchRequest(data)),
	onProductListLoadRequest: () => dispatch(actionsProduct.loadListRequest()),
	onTabChange : (type='lab_edit', tab) => dispatch(
		actionsTabToggler.changeTab(type, tab)
	),
});
const Toolbar = withRouter(AuthRedirect.AuthProps(connect(mapStateToProps, mapDispatchToProps)(component)))


export { Toolbar }
